var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSwapHorizontalCircleBlack24Dp = function SvgSwapHorizontalCircleBlack24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "swap_horizontal_circle_black_24dp"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\xE5\\xBD\\xA2\\xE7\\x8A\\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 9C1.5 4.86 4.86 1.5 9 1.5C13.14 1.5 16.5 4.86 16.5 9C16.5 13.14 13.14 16.5 9 16.5C4.86 16.5 1.5 13.14 1.5 9ZM3 9C3 12.3075 5.6925 15 9 15C12.3075 15 15 12.3075 15 9C15 5.6925 12.3075 3 9 3C5.6925 3 3 5.6925 3 9ZM11.25 4.875V6.75H8.25V8.25H11.25V10.125L13.875 7.5L11.25 4.875ZM4.125 10.5L6.75 7.875V9.75H9.75V11.25H6.75V13.125L4.125 10.5Z",
    fill: "currentColor"
  }))));
};

export { SvgSwapHorizontalCircleBlack24Dp as ReactComponent };
export default __webpack_public_path__ + "733e4e43292dd380cb2779c3a697e64d.svg";